import { ChangeEvent } from "react";
import { Input } from "antd";

interface ICustomSearch {
  onSearchChange: (e: ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  value?: string;
}

export default function CustomSearch({ onSearchChange, placeholder = "Search...", value = "" }: ICustomSearch) {
  return <Input.Search className="custom-search" placeholder={placeholder} onChange={onSearchChange} value={value} />;
}
